import styled from "styled-components";
import {useEffect, useState} from "react";
import {Deployment, Job, Skeleton} from "../api/types";
import {agent} from "../api/agent";
import SearchInput from "./Search/SearchInput";
import {useNavigate} from "react-router-dom";
import SyncedList from "./SyncedList";


const Container = styled.div`
    
    .content {
        display: grid;
        gap: 1rem;
        justify-content: center;
        margin: 1rem 0;
        grid-template-columns: 40%;
    }
    
    .job-item {
        background-color: var(--content-box-bg);
        box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
        padding: 2rem;
        display: grid;
        grid-template-columns: auto auto;
    }
    
    .job-item h1 {
        margin: 0;
    }
    
    .status {
        width: 1.5rem;
        height: 1.5rem;
        border-radius: 50%;
        display: inline-block;
        background-color: dodgerblue;
        margin: 1rem;
        position: absolute;
        right: 0;
    }
    
    .status-stopped {
        background-color: #ff0000;
    }
    
    .status-running {
        background-color: #00ff00;
    }
    
    .symbol {
        font-size: 1.2rem;
        cursor: pointer;
        &-stop {
            color: #ff0000;   
        }
        &-start {
            color: #00ff00;
        }
    }
    
`;


export default function DeploymentsList() {


    const [deployments, setDeployments] = useState<Deployment[]>([]);
    const [filteredDeployments, setFilteredDeployments] = useState<Deployment[]>([]);
    const navigate = useNavigate();


    useEffect(() => {
        const syncedList = new SyncedList<Deployment>();
        const id = agent.subscribe('/deployment', (value: Deployment[]) => {
            syncedList.processData(value);

            setDeployments([...syncedList.getList()]);
        });
        return () => agent.unsubscribe(id);
    }, []);

    const start = (id: string) => {
        agent.startDeployment(id).then(() => {});
    }

    const stop = (id: string) => {
        agent.stopDeployment(id).then(() => {});
    }

    return (<Container>

        <div className={'content'}>
            <SearchInput data={deployments} setSearchResult={setFilteredDeployments} searchableKeys={['deploymentName', 'repo', 'deploymentId']}></SearchInput>
            {filteredDeployments.map((job, index) => (
                <div className={'job-item'} key={index}>
                    <h1>{job.deploymentName || job.repo.repo}</h1>
                    <div style={{position: 'relative'}}>
                        <div className={'status status-'+job.currentStatus}></div>
                    </div>
                    <div>{job.currentStatus === 'stopped' ? (<span className={'symbol symbol-start'} onClick={() => start(job.deploymentId)}>▶</span>) : (<span className={'symbol symbol-stop'} onClick={() => stop(job.deploymentId)}>⏹</span>)}</div>

                </div>
            ))}
        </div>

    </Container>);

}